var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "8",
      "xl": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "lg"
    }
  }, [_c('v-tabs', {
    attrs: {
      "centered": ""
    },
    model: {
      value: _vm.form.tab,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tab", $$v);
      },
      expression: "form.tab"
    }
  }, [_c('v-tabs-slider')], 1), _c('v-tabs-items', {
    model: {
      value: _vm.form.tab,
      callback: function ($$v) {
        _vm.$set(_vm.form, "tab", $$v);
      },
      expression: "form.tab"
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "px-10",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.form.valid,
      callback: function ($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "tab-dados-cadastrais",
      "eager": ""
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "7"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome",
      "maxlength": "80",
      "outlined": "",
      "dense": "",
      "rules": [_vm.$required],
      "disabled": _vm.dados.tipoUsuario === _vm.TipoUsuarioEnum.INTERNO
    },
    model: {
      value: _vm.dados.nome,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "nome", $$v);
      },
      expression: "dados.nome"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex align-center margin-top-negative",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._v(" Inserir Nome Social "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "right": ""
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-chat-question-outline")])];
            }
          }])
        }, [_c('span', {
          staticClass: "custom-tooltip"
        }, [_vm._v(" Nome social é a designação pela qual a pessoa travesti ou transexual se identifica"), _c('br'), _vm._v(" e é socialmente reconhecida e deverá ser composto por prenome, acrescido do(s)"), _c('br'), _vm._v(" sobrenome(s) familiar(es) constante(s) do nome civil, não podendo ser irreverente"), _c('br'), _vm._v(" ou atentar contra o pudor. ")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dados.inserirNomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "inserirNomeSocial", $$v);
      },
      expression: "dados.inserirNomeSocial"
    }
  })], 1)], 1), _vm.dados.inserirNomeSocial ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome Social",
      "outlined": "",
      "maxlength": "80",
      "counter": "80",
      "dense": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.dados.nomeSocial,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "nomeSocial", $$v);
      },
      expression: "dados.nomeSocial"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###.###.###-##',
      expression: "'###.###.###-##'"
    }],
    attrs: {
      "label": "CPF",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.dados.cpf,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "cpf", $$v);
      },
      expression: "dados.cpf"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "outlined": "",
      "dense": "",
      "disabled": ""
    },
    model: {
      value: _vm.dados.email,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "email", $$v);
      },
      expression: "dados.email"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail Secundário",
      "maxlength": "100",
      "counter": "100",
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return _vm.$emailNotRequired(v);
      }]
    },
    model: {
      value: _vm.dados.emailSecundario,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "emailSecundario", $$v);
      },
      expression: "dados.emailSecundario"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '(##) #####-####',
      expression: "'(##) #####-####'"
    }],
    attrs: {
      "label": "Telefone*",
      "hint": "Número de preferência que seja WhatsApp",
      "hide-details": "auto",
      "maxlength": "15",
      "dense": "",
      "outlined": "",
      "rules": [_vm.$required, _vm.$validarDDD]
    },
    on: {
      "input": _vm.$formatarTelefone
    },
    model: {
      value: _vm.dados.telefone,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "telefone", $$v);
      },
      expression: "dados.telefone"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem*",
      "dense": "",
      "outlined": "",
      "items": _vm.origens,
      "item-text": "nome",
      "item-value": "id",
      "rules": [_vm.$required]
    },
    on: {
      "change": _vm.verificarOrigemSelecionada
    },
    model: {
      value: _vm.dados.origemId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "origemId", $$v);
      },
      expression: "dados.origemId"
    }
  })], 1)], 1), _c('v-row', [_vm.mostrarNomeGre ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Nome da GRE*",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "items": _vm.listaGerenciasRegionais,
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.dados.greId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "greId", $$v);
      },
      expression: "dados.greId"
    }
  })], 1) : _vm._e(), _vm.mostrarSecretariaExecutiva ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Secretaria Executiva*",
      "dense": "",
      "outlined": "",
      "items": _vm.listaSecretarias,
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.dados.secretariaId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "secretariaId", $$v);
      },
      expression: "dados.secretariaId"
    }
  })], 1) : _vm._e()], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Função*",
      "dense": "",
      "outlined": "",
      "items": _vm.listaFuncoes,
      "item-text": "nome",
      "item-value": "id",
      "rules": [_vm.$required]
    },
    on: {
      "change": _vm.atualizarCamposPorFuncao
    },
    model: {
      value: _vm.dados.funcaoId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "funcaoId", $$v);
      },
      expression: "dados.funcaoId"
    }
  })], 1), !_vm.mostrarDisciplina ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Setor*",
      "dense": "",
      "outlined": "",
      "items": _vm.listaSetores,
      "item-text": "nome",
      "item-value": "id",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.dados.setorId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "setorId", $$v);
      },
      expression: "dados.setorId"
    }
  })], 1) : _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Disciplina*",
      "dense": "",
      "outlined": "",
      "items": _vm.listaDisciplinas,
      "item-text": "nome",
      "item-value": "id",
      "return-object": "",
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.dados.disciplinaId,
      callback: function ($$v) {
        _vm.$set(_vm.dados, "disciplinaId", $$v);
      },
      expression: "dados.disciplinaId"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('sigfoco-buttons', {
    on: {
      "click": _vm.atualizarDadosDoProfissional,
      "cancel": _vm.cancelar
    }
  })], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }